// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".countDownView[data-v-181258b1] {\n  display: flex;\n  align-items: center;\n  margin: 5px 0 0 0;\n}\n.titleText[data-v-181258b1] {\n  color: #F99B0D;\n  font-size: 14px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
